import { render, staticRenderFns } from "./ErrorScreen.vue?vue&type=template&id=6f2be3c8&scoped=true&"
import script from "./ErrorScreen.vue?vue&type=script&lang=ts&"
export * from "./ErrorScreen.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorScreen.vue?vue&type=style&index=0&id=6f2be3c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2be3c8",
  null
  
)

export default component.exports